import { TourGuideType } from "@root/constants/tour-guide";

const STORAGE_KEY_PREFIX = "tourguide_completed_";

const UNAUTHENTICATED_TOUR_TYPES: TourGuideType[] = [
  TourGuideType.UnauthenticatedDashboard,
  TourGuideType.UnauthenticatedCourses,
  TourGuideType.UnauthenticatedCourseDetail,
];

function storageKey(type: TourGuideType): string {
  return `${STORAGE_KEY_PREFIX}${type}`;
}

function isStorageAvailable(): boolean {
  try {
    const k = "__tourguide_storage_check__";
    localStorage.setItem(k, "1");
    localStorage.removeItem(k);
    return true;
  } catch {
    return false;
  }
}

export function isUnauthTourType(type: TourGuideType): boolean {
  return UNAUTHENTICATED_TOUR_TYPES.includes(type);
}

export function getTourCompleted(type: TourGuideType): boolean {
  if (!isStorageAvailable() || !isUnauthTourType(type)) return false;
  try {
    return localStorage.getItem(storageKey(type)) === "true";
  } catch {
    return false;
  }
}

export function setTourCompleted(type: TourGuideType): void {
  if (!isStorageAvailable() || !isUnauthTourType(type)) return;
  try {
    localStorage.setItem(storageKey(type), "true");
  } catch {
    // ignore (e.g. private mode, quota)
  }
}
